import { FormattedMessage } from 'react-intl';

import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import { RocketOutlined } from '@ant-design/icons';

// icons
const icons = { RocketOutlined };

export const collaborations: NavItemType = {
  id: 'collaborations-menu',
  type: 'group',
  children: [
    {
      id: 'collaborations',
      title: <FormattedMessage id="collaborations" />,
      type: 'collapse',
      icon: icons.RocketOutlined,
      children: [
        {
          id: 'collaboration-setup',
          title: <FormattedMessage id="campaigns-setup" />,
          type: 'item',
          url: '/collaborations/campaign-setup/tiktok-shop/'
        },
        {
          id: 'collaboration-review',
          title: <FormattedMessage id="collaboration-review" />,
          type: 'item',
          url: '/collaborations/collaboration-review'
        },
        {
          id: 'samples-management',
          title: <FormattedMessage id="samples-management" />,
          type: 'item',
          url: '/collaborations/samples-management/tiktok-shop/'
        }
      ]
    }
  ]
};
